module.exports = __webpack_public_path__ + "610cda9eb7eea2c5383ebb4fa0869352.svg";